// extracted by mini-css-extract-plugin
export const card = "example-card-module--card--J4gT+";
export const dropdownTest = "example-card-module--dropdownTest--68LRs";
export const img = "example-card-module--img--0qYob";
export const left = "example-card-module--left--mTa06";